import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";

import { useEffect, useState } from "react";
import "./Home.css";

import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";

import dayjs from "dayjs";

// Generated by GitHub Copilot
import LeftNavigation from "../LeftNavigation/LeftNavigation";
import { LightModeLayout } from "../Layout/LightModeLayout";
const relativeTime = require("dayjs/plugin/relativeTime");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

function ProblemRow(props) {
  const upperFirst = (word) => {
    return word[0].toUpperCase() + word.substring(1);
  };

  const problemLink = "/problem/view/" + props.problem.number;
  const prbClassName = `${
    props.problem && props.problem.priority ? props.problem.priority : "EP4"
  } problemcol emphatic`;
  return (
    <Row className="problemrow" data-testid="problem-row">
      <Col
        className="problemcol emphatic problemnumber"
        xs={4}
        sm={4}
        md={3}
        lg={3}
        xl={2}
      >
        <Link to={problemLink}>{props.problem.number}</Link>
      </Col>
      <Col
        className={prbClassName}
        xs={3}
        sm={2}
        md={2}
        lg={2}
        xl={1}
        data-testid="priority-badge"
      >
        {props.problem.priority
          ? upperFirst(props.problem.priority)
          : props.problem.severity}
      </Col>
      <Col className="problemcol" xs={5} sm={4} md={3} lg={5} xl={5}>
        {props.problem.short_description
          ? props.problem.short_description
          : "No Title"}
      </Col>
      {props.showSlack ? (
        <Col
          className="problemcol d-none d-xl-block"
          xs={0}
          sm={0}
          md={0}
          lg={0}
          xl={3}
        >
          {props.problem.slack ? props.problem.slack : ""}
        </Col>
      ) : (
        <></>
      )}

      {props.showEnd && (
        <Col
          className="problemcol d-none d-xl-block"
          xs={0}
          sm={0}
          md={0}
          lg={0}
          xl={4}
        >
          {props.problem.ended
            ? dayjs(props.problem.ended).format("MM/DD/YY HH:mm:ss z")
            : ""}
        </Col>
      )}
    </Row>
  );
}

function Home(props) {
  // const [error, setError] = useState("");
  const [openLoaded, setOpenLoaded] = useState(false);
  const [rows, setRows] = useState();
  const [resolvedLoaded, setResolvedLoaded] = useState(false);
  const [resolvedRows, setResolvedRows] = useState();

  const [iterator, setIterator] = useState(0);

  const [error, setError] = useState();

  // Combined loading state - true when both are loaded
  const loaded = openLoaded && resolvedLoaded;

  useEffect(() => {
    const getProblems = (category, showSlack) => {
      const queryString = category ? `?category=${category}` : "";

      return new Promise((resolve, reject) => {
        fetch(`/api/v1/problem${queryString}`)
          .then((response) => {
            if (response.status !== 200) {
              reject("Unable to Fetch Problem Notes");
            }
            return response.json();
          })
          .then(
            (result) => {
              if (result.problems) {
                const rows = result.problems.map((p) => {
                  const firstOutage = Object.keys(p.outages)[0];

                  let showStatus = true;
                  let showStart = true;
                  let showEnd = false;

                  p.priority = p.outages[firstOutage].priority;

                  // legacy support
                  p.severity = p.outages[firstOutage].severity;

                  p.description = p.outages[firstOutage].description;
                  p.short_description =
                    p.outages[firstOutage].short_description;
                  p.mim = p.outages[firstOutage].mim;

                  p.slack = p.outages[firstOutage].slackChannel;
                  p.status = p.outages[firstOutage].status;
                  p.started = p.outages[firstOutage].incidentStart;

                  if (p.outages[firstOutage].status === "Resolve") {
                    p.slack = "";
                    showStatus = false;
                    showStart = false;
                    showEnd = true;
                    p.ended = p.outages[firstOutage].incidentEnd;
                  }

                  return (
                    <ProblemRow
                      problem={p}
                      key={p.number}
                      showStatus={showStatus}
                      showStart={showStart}
                      showEnd={showEnd}
                      showSlack={p.slack !== ""}
                    />
                  );
                });
                resolve(rows);
              }

              setTimeout(() => {
                setOpenLoaded(true);
              }, 500);
            },

            (error) => {
              setOpenLoaded(true);
              console.error(error);
            }
          )
          .catch((e) => {
            console.error(e);
          });
      });
    };

    setOpenLoaded(false);

    // Generated by GitHub Copilot
    // Track timeout for cleanup
    let refreshTimeout;

    getProblems("open", true)
      .then((rows) => {
        setRows(rows);

        if (!props.debug) {
          refreshTimeout = setTimeout(() => {
            setIterator(iterator + 1);
          }, 60000);
        }
      })
      .catch((e) => {
        setError("Error fetching problem notes - E1001");
      });

    // Fetch resolved problems
    setResolvedLoaded(false);
    getProblems("resolved", false)
      .then((rows) => {
        setResolvedRows(rows);
        setResolvedLoaded(true);
      })
      .catch((e) => {
        console.error("Error fetching resolved problems:", e);
        setResolvedLoaded(true);
      });

    // Generated by GitHub Copilot
    // Cleanup function to clear timeout when component unmounts
    return () => {
      if (refreshTimeout) {
        clearTimeout(refreshTimeout);
      }
    };
  }, [props, iterator]);

  // Track classic UI page view for usage analytics
  // User identity is attached globally via setUserId in AppWrapper
  const userEmail = props.user?.email;
  const { newrelic } = props;
  useEffect(() => {
    if (!userEmail) return;
    newrelic?.addPageAction('ClassicUI.Incidents.View', {
      uiType: 'classic',
      pageUrl: window.location.href
    });
  }, [userEmail, newrelic]);

  // Generated by GitHub Copilot
  // Early return if user is not loaded yet (after all hooks are defined)
  if (!props.user) {
    return <div>Loading user data...</div>;
  }

  return (
    <LightModeLayout>
      <Container className="px-0" style={{ marginLeft: "-15px" }}>
        {error ? (
          <Row>
            <Col>
              <p className="errorMessage">{error}</p>
            </Col>
          </Row>
        ) : (
          <></>
        )}
        <Row>
          {/* Left navigation */}
          <Col xs={12} sm={4} md={3} lg={3} xl={2} className="d-none d-sm-block">
            <LeftNavigation user={props.user} newrelic={newrelic} />
          </Col>

          {/* Main content area */}
          <Col xs={12} sm={8} md={9} lg={9} xl={10}>
            {!loaded && <div className="loading-box">LOADING</div>}
            <Collapse in={loaded}>
              <div>
                {/* Ongoing Problems Section */}
                <Row className="mt-3">
                  <Col xs={12}>
                    <h3 data-testid="ongoing-heading">Ongoing</h3>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    {rows && rows.length > 0 ? (
                      <>
                        <Row className="table-header">
                          <Col xs={4} sm={4} md={3} lg={3} xl={2}>
                            <b>PRB</b>
                          </Col>
                          <Col xs={3} sm={2} md={2} lg={2} xl={1}>
                            <b>Priority</b>
                          </Col>
                          <Col xs={5} sm={4} md={3} lg={5} xl={5}>
                            <b>Description</b>
                          </Col>
                          <Col
                            className="d-none d-xl-block"
                            xs={0}
                            md={0}
                            lg={0}
                            xl={3}
                          >
                            <b>Slack Channel</b>
                          </Col>
                        </Row>
                        {rows}
                      </>
                    ) : (
                      <Row>
                        <Col
                          data-testid="no-open-problems"
                          className="no-problems-message"
                        >
                          No Problems Currently Open
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>

                {/* Recently Resolved Section */}
                <Row className="mt-5">
                  <Col xs={12}>
                    <h3 data-testid="recently-resolved-heading">
                      Recently Resolved
                    </h3>
                  </Col>
                </Row>
                <Row data-testid="recently-resolved-rows">
                  <Col xs={12}>
                    {resolvedRows && resolvedRows.length > 0 ? (
                      <>
                        <Row className="table-header">
                          <Col xs={4} sm={4} md={3} lg={3} xl={2}>
                            <b>PRB</b>
                          </Col>
                          <Col xs={3} sm={2} md={2} lg={2} xl={1}>
                            <b>Priority</b>
                          </Col>
                          <Col xs={5} sm={4} md={3} lg={5} xl={5}>
                            <b>Description</b>
                          </Col>
                          <Col
                            className="d-none d-xl-block"
                            xs={0}
                            md={0}
                            lg={0}
                            xl={4}
                          >
                            <b>Incident End</b>
                          </Col>
                        </Row>
                        {resolvedRows}
                      </>
                    ) : (
                      <Row>
                        <Col className="no-problems-message">
                          No Recently Resolved Problems
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </div>
            </Collapse>
          </Col>
        </Row>
      </Container>
    </LightModeLayout>
  );
}

export default Home;
